import hero from '../../../assets/imgs/inProgress/home/hero.png';
import heroA from '../../../assets/imgs/inProgress/home/hero_a.png';
import heroB from '../../../assets/imgs/inProgress/home/hero_b.png';
import { BUILDING } from '../../../utils/Constants';
import { areasA, areasB } from '../data/InProgressBuildingPaths';
import useInProgress from '../hooks/useInProgress';

const InProgressBuilding = ({
  openActiveBuildingModal,
}: {
  openActiveBuildingModal: (building: string, floor: string) => void;
}) => {
  const { hoveredArea, setHoveredArea } = useInProgress();

  const handleHeroOpacity = (isVisible: boolean, image: string) => {
    const a = document.getElementById('overlay_a');
    const b = document.getElementById('overlay_b');

    if (image === BUILDING.A && a) {
      if (isVisible) {
        a.style.opacity = '1';
      } else {
        a.style.opacity = '0';
      }
    }

    if (image === BUILDING.B && b) {
      if (isVisible) {
        b.style.opacity = '1';
      } else {
        b.style.opacity = '0';
      }
    }
  };

  return (
    <div className='inprogress_page_building'>
      <svg viewBox='0 0 1920 1080' xmlns='http://www.w3.org/2000/svg'>
        <image
          href={hero}
          width='100%'
          height='100%'
          preserveAspectRatio='xMidYMid slice'
        />
        <image
          id='overlay_a'
          href={heroA}
          width='100%'
          height='100%'
          preserveAspectRatio='xMidYMid slice'
        />
        <image
          id='overlay_b'
          href={heroB}
          width='100%'
          height='100%'
          preserveAspectRatio='xMidYMid slice'
        />
        {areasA.map((area) => {
          return (
            <polygon
              key={area.building + area.floor}
              points={area.coords}
              fill={
                hoveredArea === area.building + area.floor
                  ? '#FFFFFF66'
                  : '#FFFFFF00'
              }
              onMouseEnter={() => {
                setHoveredArea(area.building + area.floor);
                handleHeroOpacity(true, BUILDING.A);
              }}
              onMouseLeave={() => {
                setHoveredArea(null);
                handleHeroOpacity(false, BUILDING.A);
              }}
              onClick={() => {
                openActiveBuildingModal(area.building, area.floor);
              }}
            />
          );
        })}
        {areasB.map((area) => {
          return (
            <polygon
              key={area.building + area.floor}
              points={area.coords}
              fill={
                hoveredArea === area.building + area.floor
                  ? '#FFFFFF66'
                  : '#FFFFFF00'
              }
              onMouseEnter={() => {
                setHoveredArea(area.building + area.floor);
                handleHeroOpacity(true, BUILDING.B);
              }}
              onMouseLeave={() => {
                setHoveredArea(null);
                handleHeroOpacity(false, BUILDING.B);
              }}
              onClick={() => {
                openActiveBuildingModal(area.building, area.floor);
              }}
            />
          );
        })}
      </svg>
    </div>
  );
};
export default InProgressBuilding;
